document.addEventListener('DOMContentLoaded', function() {
  function toggleSubscriptionPrice(showSubscription) {
    const priceElements = document.querySelectorAll('.f-price');

    priceElements.forEach(priceElement => {
      const oneTimePrices = priceElement.querySelectorAll('[data-one-time-price]');
      const subscriptionPrices = priceElement.querySelectorAll('[data-subscription-price]');

      oneTimePrices.forEach(el => {
        el.style.display = showSubscription ? 'none' : '';
      });

      subscriptionPrices.forEach(el => {
        el.style.display = showSubscription ? '' : 'none';
      });
    });
  }

  // Listen for Recharge widget changes
  document.addEventListener('change', function(e) {
    // Check if the change event is from Recharge subscription radio/checkbox
    // Adjust selector based on your Recharge widget implementation
    if (e.target.matches('[name="selling_plan"], .rc-radio input, .rc-widget input[type="radio"], .recharge-input')) {
      const isSubscription = e.target.value && e.target.value !== '' && e.target.checked;
      toggleSubscriptionPrice(isSubscription);
    }
  });

  // Also listen for Recharge-specific events
  document.addEventListener('recharge:variant:changed', function(e) {
    const isSubscription = e.detail && e.detail.selling_plan_id;
    toggleSubscriptionPrice(isSubscription);
  });

  // Listen for custom events that might be triggered by Recharge
  window.addEventListener('message', function(e) {
    if (e.data && e.data.type === 'recharge:subscription:toggle') {
      toggleSubscriptionPrice(e.data.subscriptionSelected);
    }
  });

  // -- ih: Sale Price Override for ReCharge widget one-time price --
  function applyReChargeSaleOverride() {
    // Get sale config from the PDP price wrapper
    const priceWrapper = document.querySelector('.f-price[data-ih-sale-type]');
    if (!priceWrapper) return;

    const saleType = priceWrapper.dataset.ihSaleType || 'percent';
    const salePercent = parseInt(priceWrapper.dataset.ihSalePercent);
    const saleFixed = parseFloat(priceWrapper.dataset.ihSaleFixed);

    if (saleType === 'percent' && (!salePercent || salePercent <= 0)) return;
    if (saleType === 'fixed' && (!saleFixed || saleFixed <= 0)) return;

    // Find ReCharge widget — try both light DOM and shadow DOM approaches
    const rcWidgets = document.querySelectorAll('recharge-subscription-widget, rc-widget');
    rcWidgets.forEach(function(widget) {
      const root = widget.shadowRoot || widget;
      const onetimeOption = root.querySelector('.rc-purchase-option__onetime, .rc-selection__onetime');
      if (!onetimeOption) return;

      const priceEl = onetimeOption.querySelector('.rc-price, [part~="rc-purchase-option__price"]');
      if (!priceEl || priceEl.dataset.ihSaleApplied) return;

      const priceText = priceEl.textContent.trim();
      const match = priceText.match(/([\$£€]?)([\d,]+\.?\d*)/);
      if (!match) return;

      const symbol = match[1];
      const originalValue = parseFloat(match[2].replace(',', ''));
      const discountedValue = saleType === 'fixed'
        ? (originalValue - saleFixed).toFixed(2)
        : (originalValue - (originalValue * salePercent / 100)).toFixed(2);

      priceEl.textContent = symbol + discountedValue;
      priceEl.dataset.ihSaleApplied = 'true';
    });
  }

  // ReCharge renders async in shadow DOM — observe for the widget element,
  // then observe its shadowRoot for the inner content to render.
  let rcShadowObserver = null;

  function watchForReChargeWidget() {
    const rcWidgets = document.querySelectorAll('recharge-subscription-widget, rc-widget');
    rcWidgets.forEach(function(widget) {
      if (widget.dataset.ihSaleWatching) return;
      widget.dataset.ihSaleWatching = 'true';

      // If shadowRoot exists, observe it for content changes
      if (widget.shadowRoot) {
        applyReChargeSaleOverride();
        if (!rcShadowObserver) {
          rcShadowObserver = new MutationObserver(function() {
            applyReChargeSaleOverride();
          });
        }
        rcShadowObserver.observe(widget.shadowRoot, {
          childList: true,
          subtree: true
        });
      }
    });
  }

  // Observe body for the rc-widget element to appear
  const rcBodyObserver = new MutationObserver(function() {
    watchForReChargeWidget();
  });

  rcBodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also try on delays as fallback
  setTimeout(watchForReChargeWidget, 1000);
  setTimeout(watchForReChargeWidget, 2500);
  setTimeout(watchForReChargeWidget, 5000);
});